import type { TokenRejectionClassifier } from '../../../lib/integration-auth';

const TEXT_PLAIN_CONTENT_TYPE_PATTERN = /^text\/plain(?:\s*;|$)/i;

export const classifyGitlabTokenRejection: TokenRejectionClassifier = ({ status, headers }) => {
  if (status !== 429) {
    return undefined;
  }

  const throttleName = headers.get('RateLimit-Name');
  if (
    (throttleName === 'throttle_unauthenticated_api' ||
      throttleName === 'throttle_authenticated_api') &&
    headers.get('RateLimit-Remaining') === '0' &&
    TEXT_PLAIN_CONTENT_TYPE_PATTERN.test(headers.get('Content-Type') ?? '')
  ) {
    return 'rate_limited';
  }

  return undefined;
};
